const selectTemplate = require('./view/select.handlebars');
const BASE_SELECTOR: string = "[data-logs]";
const FILE_SELECTOR: string = "[data-file]"

export class LogsUI {

  // DOM Node of autoscroll checkbox
  private $autoscrollCheckbox: JQuery = this.$base.find('.fancy-checkbox');

  // DOM Node of textarea
  private $textarea: JQuery = this.$base.find('textarea');

  // State for the autoscroll
  public autoscroll: boolean = true;

  public constructor(private $base: JQuery) {
    this.disableAutoScrollOnScroll();
    this.onChangeAutoScroll();
  }

  private onChangeAutoScroll() {
    this.$autoscrollCheckbox.on('click', () => {
      if (this.$autoscrollCheckbox.find('input').prop('checked')) {
        this.autoscroll = true;
      } else {
        this.autoscroll = false;
      }
    });
  }

  // getFiles
  public getFiles() {
    const data = this.$base.data('logs');
    return data;
  }

  // disable autoscroll if the users scroll to top
  private disableAutoScrollOnScroll() {
    let lastScrollTop = 0;
    this.$textarea.on('scroll', () => {
      var st = this.$textarea.scrollTop();
      if (st > lastScrollTop) {
        // downscroll code
      } else {
        // upscroll code
        this.disableAutoscroll();
      }
      lastScrollTop = st;
    });
  }

  // Disable autoscroll
  private disableAutoscroll() {
    this.autoscroll = false;
    if (this.$autoscrollCheckbox.hasClass('is-active')) {
      this.$autoscrollCheckbox.trigger('click');
    }
  }

  // Update the log in the textarea
  public update(content) {
    this.$textarea.text(content);

    if(this.autoscroll) {
      this.$textarea.scrollTop(this.$base.find('textarea')[0].scrollHeight)
    }
  }

  public renderSelectbox(files: any, afterRender: () => {}) {
    this.$base.find(FILE_SELECTOR).html(selectTemplate({files: files}));
    afterRender();
  }

  public onChangeFile(callback: (value: any) => {}) {
    this.$base.find('select').on('change', () => {
      callback(this.$base.find('select').val());
    })
  }
}

export function createLogsInstances(): LogsUI[] {
  const instances: LogsUI[] = [];

  $(BASE_SELECTOR).each((i, el) => {
    instances.push(new LogsUI($(el)));
  })

  return instances;
}
